import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  FaArrowRight,
  FaChartBar,
  FaChevronRight,
  FaGlobe,
  FaProjectDiagram,
  FaUniversity,
  FaWhatsapp,
} from "react-icons/fa";

import styles from "../styles_home/HeroSection.module.css";
import sliderStyles from "../styles/Banner.module.css";
import ConsultationModal from "../components/ConsultationModal";

const services = [
  {
    title: "Government Portal Development",
    icon: FaUniversity,
  },
  {
    title: "WhatsApp Automation",
    icon: FaWhatsapp,
  },
  {
    title: "MIS & Dashboards",
    icon: FaChartBar,
  },
  {
    title: "Workflow Automation",
    icon: FaProjectDiagram,
  },
  {
    title: "Global Software Services",
    icon: FaGlobe,
    path: "/global-software-services",
  },
];

const carouselAngles = ["0deg", "90deg", "180deg", "270deg"];

const HeroSection = () => {
  const [isConsultationModalOpen, setIsConsultationModalOpen] =
    useState(false);

  return (
    <>
      <section className={styles.heroSection}>
        <div className={styles.bgElements} aria-hidden="true">
          <div className={styles.gradientOrb}></div>
          <div className={styles.bottomGlow}></div>
          <div className={styles.gridPattern}></div>
        </div>

        <div className={styles.lightBeam} aria-hidden="true"></div>

        <div className={styles.heroContainer}>
          <div className={styles.leftContent}>
            <h1 className={styles.headline}>
              <span className={styles.headingLine}>
                Build Software That
              </span>

              <span className={styles.gradientText}>
                Simplifies Your Work
              </span>
            </h1>

            <p className={styles.description}>
              Custom software, websites, apps, and automation solutions
              designed to help businesses grow faster.
            </p>

            <div className={styles.serviceCards}>
              {services.map((service) => {
                const ServiceIcon = service.icon;
                const CardElement = service.path ? Link : "div";

                const cardProps = service.path
                  ? { to: service.path }
                  : {};

                return (
                  <CardElement
                    className={styles.serviceCard}
                    key={service.title}
                    {...cardProps}
                  >
                    <div className={styles.serviceIconWrapper}>
                      <ServiceIcon className={styles.serviceIcon} />
                    </div>

                    <span className={styles.serviceTitle}>
                      {service.title}
                    </span>
                  </CardElement>
                );
              })}
            </div>

            <div className={styles.ctaGroup}>
              <button
                type="button"
                onClick={() => setIsConsultationModalOpen(true)}
                className={styles.primaryCta}
              >
                <span>Book a Free Consultation</span>
                <FaArrowRight className={styles.arrowIcon} />
              </button>

              <Link to="/services" className={styles.secondaryCta}>
                <span>View Services</span>
                <FaChevronRight className={styles.secondaryArrow} />
              </Link>
            </div>
          </div>

          <div className={styles.rightContent}>
            <div className={styles.sliderGlow} aria-hidden="true"></div>

            <div
              className={styles.frontCardFloorGlow}
              aria-hidden="true"
            ></div>

            <div className={styles.carouselViewport}>
              <div className={styles.carouselScale}>
                <div
                  className={`${sliderStyles.slider} ${styles.heroSlider}`}
                  style={{ "--quantity": 4 }}
                >
                  {[...Array(4)].map((_, index) => (
                    <div
                      className={`${sliderStyles.item} ${styles.heroSliderItem}`}
                      style={{
                        "--position": index + 1,
                        "--card-angle": carouselAngles[index],
                      }}
                      key={index}
                    >
                      <img
                        src={`/images/cards/card${index}.png`}
                        alt={`VishvaConnect service ${index + 1}`}
                        draggable="false"
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ConsultationModal
        isOpen={isConsultationModalOpen}
        onClose={() => setIsConsultationModalOpen(false)}
      />
    </>
  );
};

export default HeroSection;